module.exports = __webpack_public_path__ + "static/TANMEMORIES-Regular-1471c9fa108455f0f509bcb39872b919.woff";